App.controller('FlotStackedChartControllerStat', ['$scope', '$window','$http', '$filter', '$timeout', '$rootScope',
                                           function($scope, $window, $http, $filter,$timeout, $rootScope) {
      'use strict';

      /**
       * Global object to load data for charts using ajax
       * Request the chart data from the server via post
       * Expects a response in JSON format to init the plugin
       * Usage
       *   chart = new floatChart(domSelector || domElement, 'server/chart-data.php')
       *   ...
       *   chart.requestData(options);
       *
       * @param  Chart element placeholder or selector
       * @param  Url to get the data via post. Response in JSON format
       */
      $window.StackedFlotChart = function (element, url) {
        // Properties
        this.element = $(element);
        this.url = url;

        // Public method
        this.requestData = function (option, method, callback) {
          var self = this;

          // support params (option), (option, method, callback) or (option, callback)
          callback = (method && $.isFunction(method)) ? method : callback;
          method = (method && typeof method == 'string') ? method : 'GET';

          self.option = option; // save options

          $http({
              url:      self.url,
              cache:    false,
              method:   method
          }).then(function (data) {

              $.plot( self.element, data, option );

              if(callback) callback();

          }).catch(function(){
            $.error('Bad chart request.');
          });

          return this; // chain-ability

        };

        this.setData = function (option, data, type, callback) {
            var self = this;

            self.option = option; // save options
            self.data = data;

            var p=$.plot( self.element, data, option );


            var xlabel = $filter('translate')('fields.DESTINATIONS');
            var ylabel = $filter('translate')('labels.'+type.toUpperCase()+'NUMBER');

            var xaxisLabel = $('<div class="axisLabel xaxisLabel">'+xlabel+'</div>')
            .appendTo(self.element);

          var yaxisLabel = $('<div class="axisLabel yaxisLabel">'+ylabel+'</div>')
            .appendTo(self.element);



            if(!$scope.plotObjects){
                $scope.plotObjects = [];
            }
            $scope.plotObjects.push(p);
            $scope.self = self;
            $.each($('.flot-x-axis .tickLabel'), function(i, el){
				var enumlabel = $(el).html();
            	var daLabel=$filter('translate')('enums.language.'+enumlabel);
            	$(el).css('max-width','300px');
            	if(daLabel.indexOf('enums.language')>-1){
            		return;
            	}
				$(el).attr("num",$(el).html());
				daLabel = daLabel.split('(')[0];
				if(daLabel.length>15) daLabel = daLabel.substr(0,12) + '...';
				daLabel += ' - ' + enumlabel.split('_')[enumlabel.split('_').length-1];
            	$(el).html(daLabel);
          	  
          	});
            //
            if($('#'+self.element[0].id).is(":visible")){
            	$timeout((function () {
            		columnsLabelsPosFix(p,data, self.element[0].id);
            	}),500);
            }
            $('.flot-x-axis .tickLabel').bind('click',function(e){
            	//proviamo
                //$(".chart-bar-stacked.flot-chart.ng-scope .flot-overlay").trigger(e);
            	labelsClickable(p,e,self.element[0].id);
            });
            //
            self.element.resize(function(e){
            	columnsLabelsPosFix(p,data, self.element[0].id);
            	$('.flot-x-axis .tickLabel').bind('click',function(e){
                	//proviamo
                    //$(".chart-bar-stacked.flot-chart.ng-scope .flot-overlay").trigger(e);
            		labelsClickable(p,e,self.element[0].id);
                });
            });

            self.element.bind("plotclick", function(event, pos, obj) {

    			if (!obj) {
    				return;
    			}
    			var plotWidth=event.target.clientWidth;
                for(var pidx in $scope.plotObjects){
                    var p = $scope.plotObjects[pidx];
                    p.unhighlight();
                    p.highlight(0, obj.dataIndex);
                    p.highlight(1, obj.dataIndex); 
                    
                }
    			var lang = data[0].data[obj.dataIndex][0];
                angular.element('#MainView').scope().viewstatkey = lang;
                angular.element('#MainView').scope().$apply();
    		});

            if(callback) callback();

            return this; // chain-ability

          };

        // Listen to refresh events
        this.listen = function() {
          var self = this,
              chartPanel = this.element.parents('.panel').eq(0);

          // attach custom event
          chartPanel.on('panel-refresh', function(event, panel) {
            // request data and remove spinner when done
            self.requestData(self.option, function(){
              panel.removeSpinner();
            });

          });

          return this; // chain-ability
        };

      };

      $scope.init = function(){

    	    	if($scope.model && $scope.model.stat){
    	    		$scope.initialized = true;
    	            var labelFormatter = function(label, series) {
    	        		return "<div style='font-size:8pt; text-align:center; padding:2px; color:white;'>" + label + "<br/>" + Math.round(series.percent) + "%</div>";
    	        	}
    	         // Stack
    	            $timeout((function () {
    	                var Selector = '#chartstacked_'+($scope.model.stat ? $scope.model.stat : '')+'_'+$scope.band;
    	                $(Selector).each(function() {
                            var transform = null;
                            var inverseTransform = null;
    	                    //var source = $(this).data('source') || $.error('Donut: No source defined.');
                            var myBarWidth=0.3;
                            var barCounter=0;
                            for(var key in $scope.result){
								if(key!='projectsData'){
    	                    		barCounter++;
								}
    	                    }
                            if(barCounter>5){
                            	myBarWidth=0.6;
                            }
    	                    var chart = new StackedFlotChart(this),
    	                        option = {
    	                            series: {
    	                            	stack: true,
    	                                bars: {
    	                                    align: 'center',
    	                                    lineWidth: 0,
    	                                    show: true,
    	                                    barWidth: myBarWidth,
    	                                    fill: 0.9,
        	                                label: {
        	                                	display: 'outsideEnd',
        	                                    field: 'data1',  // field name
        	                                    orientation: 'horizontal',  //  or 'vertical'

        	                                     color: '#0000FF',
        	                                    'text-anchor': 'middle'
        	                                }
    	                                },
                                        highlightColor: 'rgba(153,0,255,0.5)'
    	                            },
    	                            legend: {
    	                                show: false
    	                            },
	                                grid: {
	                                    borderColor: '#eee',
	                                    borderWidth: 1,
	                                    hoverable: true,
                                        clickable: true,
	                                    backgroundColor: '#fcfcfc'
	                                },
	                                tooltip: true,
	                                tooltipOpts: {
	                                    content: function (label, x, y) {
											return $filter('translate')('labels.VIEW'+$scope.model.type.toUpperCase()+'STAT') + ': ' + $scope.values[x].t + '<br/>'
												+ $filter('translate')('labels.NORMALIZED'+$scope.model.type.toUpperCase()) + ': ' + $scope.values[x].n + '<br/>'
	                                    		+ $filter('translate')('labels.DISCOUNT') + ': ' + $scope.values[x].p + '%';
	                                    }
	                                },
	                                xaxis: {
	                                    tickColor: '#fcfcfc',
	                                    mode: 'categories',
	                                    labelHeight: 40
	                                },
	                                yaxis: {
	                                    position: 'left',
	                                    tickColor: '#eee',
	                                    labelWidth: 40,
	                                    labelHeight: 40//,
                                        //transform: transform,
                                        //inverseTransform: inverseTransform

	                                },
	                                shadowSize: 0
    	                        };

                            var colors = {
                                'context': ['#32CD32','#2E8B57'],
                                //'full': ['#2E8B57','#96C5AB'],
                                'full': ['#2E8B57','#a9fea9'],
                                //'fuzzy': ['#FFD700','#FFEB7F'],
                                'fuzzy': ['#FFD700','#fbf4cc'],
                                //'nomatch': ['#B22222','#D89090'],
                                'nomatch': ['#B22222','#fca6a6'],
                                //'total': ['#03218e','#4682b4']
                                //'total': ['#29416F','#6683A0']
                                'total': ['#29416F','#acd5fe']
                            }
                            //colori che avevi messo: 'total': ['#29416F','#6683A0']
    	                    var data = [{
	    	                    	"color" : colors[$scope.band][0],
	    	                    	"data": [  ],
	    	                    	"label": $filter('translate')('labels.'+$scope.model.type.toUpperCase()+'NUMBER'),
	    	                    	"chartType":$scope.model.type.toUpperCase()
	    	                    },{
	    	                    	"color" : colors[$scope.band][1],
	    	                    	"data": [  ],
	    	                    	"label": $filter('translate')('labels.NORMALIZED'+$scope.model.type.toUpperCase()),
	    	                    	"chartType":$scope.model.type.toUpperCase()
	    	                    }];
                            var max = -1;
							var min = -1;
							$scope.languagesCount = 1;
    	                    for(var key in $scope.result){
    	                    	if(key!='total' && key!='projectsData'){
									$scope.languagesCount++;
    	                    		var stat = $scope.result[key];
                                    var v = stat[$scope.model.type][$scope.band].value;
                                    if(max<v){
                                        max = v;
                                    }
                                    if(min<0 || min>v){
                                        min = v;
                                    }
    	                    	}
							}
							option.yaxis.max = max + max*0.1;
                            if(false && min<max/8){
                                option.yaxis.transform = function (v) {
                                    return Math.log(v+max);
                                },
                                option.yaxis.inverseTransform = function (v) {
                                    return Math.exp(v) - max;
                                }
                            }
                            $scope.values = {};
                            for(var key in $scope.result){
    	                    	if(key!='total' && key!='projectsData'){
    	                    		var stat = $scope.result[key];
                                    var v = stat[$scope.model.type][$scope.band].value;
                                    if(barCounter<3){
                                    	data[1].data.push([ " ", 0]);
        	                    		data[0].data.push([ " ", 0]);
                                    }

                                    data[1].data.push([ key, v - stat[$scope.model.type][$scope.band].valueN ]);
    	                    		data[0].data.push([ key, stat[$scope.model.type][$scope.band].valueN ]);
    	                    		if(barCounter<3){
    	                    			data[1].data.push([ "  ", 0]);
        	                    		data[0].data.push([ "  ", 0]);
                                    }


    	                    		$scope.values[key] = {
											t: $filter('display')(stat[$scope.model.type][$scope.band].value, {type:'decimal', decimals: ($scope.model.type=='money' ? 2 : 0),decimalSep:$rootScope.user.decimalSep }) + ($scope.model.type=='money' ? ' '+$filter('translate')('enums.currencySymbol.' + $scope.currency) : ''),
    	                    				n: $filter('display')(stat[$scope.model.type][$scope.band].valueN, {type:'decimal', decimals: ($scope.model.type=='money' ? 2 : 0),decimalSep:$rootScope.user.decimalSep }) + ($scope.model.type=='money' ? ' '+$filter('translate')('enums.currencySymbol.' + $scope.currency) : ''),
    	                    				p: stat[$scope.model.type][$scope.band].value>0 ? (100 - 100*stat[$scope.model.type][$scope.band].valueN / stat[$scope.model.type][$scope.band].value).toFixed(0) : 0
    	                    				};
    	                    	}
    	                    }
                            if(barCounter==3){
                            	data[1].data.push([ "   ", 0]);
	                    		data[0].data.push([ "   ", 0]);
                            }

    	                    // Send Request
    	                    chart.setData(option, data , $scope.model.type);
    	                });
    	            }),500);

    	    	} else {
    	            if(!$scope.watchActivated){
    	                $scope.watchActivated = true;
    	                $scope.$watch('model.stat', function(){
    	                    //if(!$scope.initialized){
    	                        $scope.init();
    	                    //}
    	                });
    	            }
    	        }
    	    }

      $scope.init();

      $scope.$watch('viewstatkey', function(){
          if($scope.viewstatkey=='total' && $scope.plotObjects){
              for(var pidx in $scope.plotObjects){
                  var p = $scope.plotObjects[pidx];
                  p.unhighlight();
              }
          }
          yAxisLabelsPosFix();
      });
      $scope.$watch('viewstattype', function(){
    	  yAxisLabelsPosFix();
      });
      $scope.$watch('viewstatband', function(){
    	  yAxisLabelsPosFix();
      });
	  
	$scope.pOff = '3';

	function columnsLabelsPosFix(p,data, id){
		$.each(p.getData(), function(i, el){
      	  /*var o = p.pointOffset({x: el.data[0][0], y: el.data[0][1]});
      	  $('<div class="data-point-label" style="text-align:center;color:#ffffff;">' + el.data[0][1] + '</div>').css( {
      	    position: 'absolute',
      	    left: (o.left)?o.left:0 + 35,
      	    top: o.top-83,
      	    display: 'none'
      	  }).appendTo(p.getPlaceholder()).fadeIn('slow');*/
      	  var ctx = p.getCanvas().getContext("2d");
      	  ctx.font = "14px 'Inter', sans-serif"; // set a pretty label font
            ctx.fillStyle = "white";
            var xaxis = p.getXAxes()[0]; // xAxis
            var yaxis = p.getYAxes()[0]; // yAxis
			var offset = p.getPlotOffset();
			if(offset.left<50){
				$('#'+id).removeClass('plotOffset3').addClass('plotOffset4').removeClass('plotOffset5').removeClass('plotOffset6').removeClass('plotOffset7');
			} else if(offset.left<60){
				$('#'+id).removeClass('plotOffset3').removeClass('plotOffset4').addClass('plotOffset5').removeClass('plotOffset6').removeClass('plotOffset7');
			} else if(offset.left<70){
				$('#'+id).removeClass('plotOffset3').removeClass('plotOffset4').removeClass('plotOffset5').addClass('plotOffset6').removeClass('plotOffset7');
			} else if(offset.left<80){
				$('#'+id).removeClass('plotOffset3').removeClass('plotOffset4').removeClass('plotOffset5').removeClass('plotOffset6').addClass('plotOffset7');
			}
            var dataPoint = el.datapoints.points;
            var i3=0;

            for (var i2 = 0; i2 < el.data.length; i2++){



          	  var x = dataPoint[i3];
                var y = dataPoint[i3+1];
                var xPos = xaxis.p2c(x)+((offset.left+11)/2);
                var yPos = yaxis.p2c(y)+offset.top+11;
                var yPosTop = yaxis.p2c(y)+offset.top-5;
                var yTop=p.pointOffset({x: x, y: y});
                var yBottom=p.pointOffset({x: 0, y: 0});
                var yBottomRelativ=p.pointOffset({x: 0, y: data[0].data[i2][1]});

                if(i>0){
              	  var toPrint=(el.data[i2][1]*100)/(data[0].data[i2][1]+data[1].data[i2][1]);
              	  if(toPrint>0){
              		ctx.fillStyle = "black";
              		  toPrint=$filter('display')(toPrint, {type:'decimal',decimals:0,decimalSep:$rootScope.user.decimalSep,def:0})+'%';
              		  //ctx.fillText(toPrint, xPos, yTop.top+((yBottomRelativ.top+11-yTop.top)/2));
              	  }
              	  ctx.fillStyle = "black";
              	  toPrint=(data[0].data[i2][1]+data[1].data[i2][1])
              	  if(toPrint>0){
                        if(data[0].chartType=="MONEY"){
                    		  toPrint=$filter('display')(toPrint, {type:'decimal',decimals:2,decimalSep:$rootScope.user.decimalSep,def:0})+' '+$filter('translate')('enums.currencySymbol.' + $scope.currency);
                  	  } else {
                            toPrint=$filter('display')(toPrint, {type:'decimal',decimals:0,decimalSep:$rootScope.user.decimalSep,def:0});
						}
						ctx.save();
						ctx.translate(xPos + 20, yPosTop);
						ctx.rotate(-Math.PI/3);
						ctx.fillText(toPrint, 0, 0);
						ctx.restore();
                	  }
              	  ctx.fillStyle = "white";
                }else{
              	  //ctx.fillText(el.data[i2][1].toFixed(0), xPos, yPos);
              	  if(data[0].chartType=="MONEY"){
                		var toPrintMoney=(data[0].data[i2][1]);
                		//toPrintMoney=toPrintMoney.replace(".",$scope.$parent.$root.user.decimalSep);
                		//toPrintMoney=toPrintMoney.replace(",",$scope.$parent.$root.user.decimalSep);
                		toPrintMoney=$filter('display')(toPrintMoney, {type:'decimal',decimals:2,decimalSep:$rootScope.user.decimalSep,def:0})+' '+$filter('translate')('enums.currencySymbol.' + $scope.currency);
                		//ctx.fillText(toPrintMoney, xPos, yPos);
              	  }else{
              		    //ctx.fillText($filter('display')(data[0].data[i2][1], {type:'decimal',decimals:0,decimalSep:$rootScope.user.decimalSep,def:0}), xPos, yPos);
              	  }

                }

          		  i3++;
                    i3++;
                    i3++;

            }

      	});
	}
      
      
      function yAxisLabelsPosFix(){
          if($scope.self){

        	  var baseBottom=$scope.plotObjects[0].pointOffset({x: 0, y: 0}).top;
              $.each($('.flot-y-axis.flot-y1-axis.yAxis.y1Axis'), function( indexe, ele ) {
            	  var total = $(ele.children).length;
            	  $.each($(ele.children), function( index, el ) {
            		  var toRemoveLeft=42-($(el).context.innerHTML.length)*5.79;
            		  $(el).css('left',toRemoveLeft);
            		  var toRemoveTop=((baseBottom-9-10)/(total-1));
                	  if(index>0){
                		  $(el).css('top',((baseBottom-9)-(index*toRemoveTop))+'px');
                	  }else{
                		  $(el).css('top',(baseBottom-9)+'px');

                	  }

                	});
            	});
          }
      }
      
      function labelsClickable(p,myEvent,myGraphPlaceholderId){
    	  var col = 1;
      	var series = p.getData()[0];
      	$.each(series.data, function( index, el ) {
      		if(el[0]==myEvent.currentTarget.attributes.num.value){
      			col=index+1;
      		}
        	});
      	var dataIndex = col - 1;
      	var ps = series.datapoints.pointsize;
      	var item = {
      	  datapoint: series.datapoints.points.slice(dataIndex * ps, (dataIndex + 1) * ps),
      	  dataIndex: dataIndex,
      	  series: series,
      	  seriesIndex: 0
      	};
      	$('#'+myGraphPlaceholderId).trigger('plotclick',  [ null, item ]);
      }

    }]);
